import "./ResponseTable.scss";

import React from "react";
import { useSortBy, useTable } from "react-table";

type ResponseTableProps = {
  columns: any;
  data: any;
  sortBy: any;
};

export const ResponseTable: React.FC<ResponseTableProps> = ({ columns, data, sortBy }) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data,
      //@ts-ignore TS2322
      initialState: { sortBy },
    },
    useSortBy
  );

  return (
    <table {...getTableProps()} className="responseTable__table">
      <thead>
        {headerGroups.map((headerGroup: any) => (
          <tr {...headerGroup.getHeaderGroupProps()} className="responseTable__header-cell">
            {headerGroup.headers.map((column: any) => (
              <th
                {...column.getHeaderProps(column.getSortByToggleProps())}
                className="responseTable__header-cell"
              >
                <span className="responseTable__wrapped-cell">
                  {column.isSorted ? (column.isSortedDesc ? "▼ " : "▲ ") : ""}
                  {column.render("Header")}
                </span>
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()} className="responseTable__body">
        {rows.map((row: any) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()} className="responseTable__row">
              {row.cells.map((cell: any) => {
                return (
                  <td {...cell.getCellProps()} className="responseTable__cell">
                    {cell.render("Cell")}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
